import React, { ReactElement } from 'react';

import { Table as AntTable, TableColumnType, TableColumnProps } from 'antd';

export interface IColumnGroupProps<RecordType>
  extends Omit<TableColumnType<RecordType>, 'children'> {
  children:
    | React.ReactElement<TableColumnProps<RecordType>>
    | React.ReactElement<TableColumnProps<RecordType>>[];
}

export function TableColumnGroup<RecordType>(
  props: IColumnGroupProps<RecordType>
): ReactElement {
  return <AntTable.ColumnGroup {...props} />;
}
